export default function Servicos() {
  const servicos = [
    {
      icon: 'ri-sofa-line',
      title: 'Reforma e Fabricação de Estofados',
      description: 'Especialistas em sofás, poltronas, cabeceiras e cadeiras. Trabalhamos com os tecidos mais nobres do mercado (linhos, veludos, couros naturais e tecidos tecnológicos) para garantir conforto absoluto e durabilidade extrema.',
      image: 'https://public.readdy.ai/ai/img_res/bf9a5fce93896742f3e689cc927da56c.jpg'
    },
    {
      icon: 'ri-hammer-line',
      title: 'Móveis Sob Medida e Marcenaria Fina',
      description: 'Criamos peças exclusivas que se adaptam perfeitamente ao seu espaço e estilo de vida. Da concepção do design à entrega final, cada móvel é uma obra única.',
      image: 'https://readdy.ai/api/search-image?query=custom%20made%20luxury%20furniture%20elegant%20wooden%20cabinet%20with%20fine%20craftsmanship%20bespoke%20interior%20design%20piece%20modern%20minimalist%20aesthetic%20high-end%20carpentry%20work%20sophisticated%20home%20decor%20exclusive%20furniture%20design&width=600&height=400&seq=servico-marcenaria-004&orientation=landscape'
    },
    {
      icon: 'ri-window-line',
      title: 'Cortinas e Persianas Sob Medida',
      description: 'O toque final para o controle de luminosidade e privacidade. Projetos personalizados com tecidos fluidos e sistemas modernos de instalação.',
      image: 'https://readdy.ai/api/search-image?query=elegant%20custom%20curtains%20in%20luxury%20living%20room%20flowing%20fabric%20drapes%20sophisticated%20window%20treatment%20modern%20interior%20design%20soft%20natural%20light%20high-end%20home%20decor%20refined%20textile%20design&width=600&height=400&seq=servico-cortinas-005&orientation=landscape'
    },
    {
      icon: 'ri-paint-brush-line',
      title: 'Papéis de Parede e Ambientação',
      description: 'Transforme suas paredes com texturas e estampas das melhores coleções mundiais, instaladas com perfeição técnica.',
      image: 'https://readdy.ai/api/search-image?query=luxury%20textured%20wallpaper%20in%20elegant%20room%20sophisticated%20wall%20covering%20design%20high-end%20interior%20decoration%20refined%20patterns%20modern%20aesthetic%20professional%20installation%20premium%20home%20decor&width=600&height=400&seq=servico-papel-006&orientation=landscape'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Higienização e Impermeabilização Premium',
      description: 'Proteja seu patrimônio. Utilizamos tecnologia de ponta para manter seus estofados livres de manchas, ácaros e odores, preservando a beleza original do tecido por muito mais tempo.',
      image: 'https://readdy.ai/api/search-image?query=professional%20upholstery%20cleaning%20service%20luxury%20sofa%20maintenance%20pristine%20white%20fabric%20furniture%20care%20high-end%20cleaning%20equipment%20modern%20technology%20spotless%20clean%20interior%20premium%20furniture%20protection&width=600&height=400&seq=servico-higienizacao-007&orientation=landscape'
    }
  ];

  return (
    <section className="py-16 md:py-24 bg-gray-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 sm:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Soluções Completas em Tapeçaria e Decoração de Luxo em SP.
          </h2>
          <p className="text-base sm:text-xl text-gray-600 max-w-3xl mx-auto">
            Oferecemos serviços especializados para transformar seus ambientes com elegância e sofisticação
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {servicos.map((servico, index) => (
            <div 
              key={index}
              className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 group"
            >
              <div className="relative w-full h-48 sm:h-56 overflow-hidden">
                <img 
                  src={servico.image}
                  alt={servico.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
              </div>
              
              <div className="p-5 sm:p-6">
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3">
                  {servico.title}
                </h3>
                <p className="text-gray-600 leading-relaxed text-sm">
                  {servico.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
